import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  fade,
  makeStyles,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import RoundedButton from '../../../../RoundedButton';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  actions: {
    justifyContent: 'space-between',
    padding: theme.spacing(1, 3, 3, 3),
  },
  btn: {
    marginLeft: theme.spacing(2),
  },
  title: {
    fontWeight: 500,
    paddingTop: theme.spacing(2),
    minWidth: 600 - 48,
  },
  subtitle: {
    fontSize: '1rem',
  },
  descriptionContainer: {
    borderTop: `1px solid ${fade('#000000', 0.1)}`,
    marginTop: 24,
    marginBottom: 32,
    fontSize: '1rem',
  },
  descriptionRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.5em',
    padding: 16,
    paddingLeft: 0,
    alignItems: 'baseline',
    borderBottom: `1px solid ${fade('#000000', 0.1)}`,
  },
  descriptionRowName: {
    flex: 1,
    textAlign: 'end',
    color: '#888888',
    width: 260,
    minWidth: 260,
  },
  descriptionRowValue: {
    flex: 1,
    fontWeight: '500',
  },
}));


const MenuItemDialog = ({
                          title,
                          subtitle,
                          isOpen,
                          isLoading,
                          handleClose,
                          options,
                          additionalOptions,
                          dialogActions,
                        }) => {
  const { en } = useSelector((state) => state.i18n);
  const { btn, dialogs } = en;
  const classes = useStyles();

  return <Dialog
    open={isOpen}
    onClose={isLoading ? null : handleClose}
  >
    <DialogTitle disableTypography>
      <Typography variant='h5' className={classes.title}>
        {title}
      </Typography>
    </DialogTitle>
    <DialogContent>
      <Typography component='div' color={'secondary'}>
        {subtitle}
      </Typography>
      <div className={classes.descriptionContainer}>
        {
          options.map(({ label, value }) => <div className={classes.descriptionRow}>
              <div className={classes.descriptionRowName}>
                {label}
              </div>
              <div className={classes.descriptionRowValue}>
                {value}
              </div>
            </div>
          )
        }
      </div>
    </DialogContent>

    {
      additionalOptions &&
      <DialogContent>
        <Typography className={classes.subtitle} variant='h6'>
          {dialogs.additionalOptions}
        </Typography>
        {additionalOptions}
      </DialogContent>
    }

    <DialogActions classes={{ root: classes.actions }}>
      <RoundedButton
        onClick={handleClose}
        variant='contained'
        color='secondary'
        size='small'
        disabled={isLoading}
      >
        {btn.cancel}
      </RoundedButton>
      {dialogActions}
    </DialogActions>
  </Dialog>;
};

MenuItemDialog.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func,
};

export default MenuItemDialog;
